<mat-card class="m-20" [ngClass]="{'p-0': !margins}">
  <mat-card-content fxLayout="column">
    <div class="header" *ngIf="showHeader">
      <ng-content select="ian-card-header"></ng-content>
    </div>
    <div [ngClass]="{'m-16': margins, 'mt-24': margins}" [class.content-elevation]="contentElevation">
      <ng-content select="ian-card-content"></ng-content>
    </div>
  </mat-card-content>
</mat-card>
